import { ShortcutsModalReducerState } from './types';

export const getDefaultState = (): ShortcutsModalReducerState => ({
  isOpen: false
});
